"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
exports.default = {
    siteTitle: {
        en: 'Lumi - Easy Car Rental Online Booking in Saudi Arabia',
        ar: 'لومي - تأجير سيارات اونلاين بسهولة في السعودية',
    },
    siteDescription: {
        en: 'Rent a car online with Lumi. Choose from a fleet of brand new 2023 model cars ranging from economy to luxury. 24/7 road assistance. Daily, weekly, & monthly car rental options.',
        ar: 'استئجار سيارة اونلاين مع لومي. اختر من بين أسطول سيارات 2023 الجديدة كليًا التي تتراوح من الاقتصادية إلى الفاخرة. 24/7 المساعدة على الطريق. خيارات تأجير السيارات اليومية والأسبوعية والشهرية.',
    },
    social: {
        facebook: 'Lumi Car Rental',
        twitter: 'Lumi Car Rental',
    },
    pages: {
        home: {
            title: {
                en: 'Lumi - Best Car Rental Company in Saudi Arabia',
                ar: 'لومي - أفضل مكتب تأجير سيارات في المملكة العربية السعودية',
            },
            description: {
                en: 'Car rental online bookings now made easy with Lumi! Choose from a fleet of brand new 2023 model cars ranging from economy to luxury ✓24/7 road assistance. ✓Daily, weekly, & monthly car rental options for individuals and corporations.',
                ar: 'ايجار السيارات اونلاين اصبح سهلاً مع لومي! اختر من بين أسطول سيارات 2023 الجديدة كليًا التي تتراوح من الاقتصادية إلى الفاخرة. ✓24/7 المساعدة على الطريق ✓خيارات تأجير السيارات اليومية والأسبوعية والشهرية للأفراد والشركات',
            },
        },
        fleet: {
            title: {
                en: 'Cheap Car Rental in Saudi Arabia starting from SAR 110/day | Lumi',
                ar: 'تأجير سيارات بأرخص الأسعار في السعودية تبدأ من 110 ريال سعودي اليوم - Lumi',
            },
            description: {
                en: 'Find best car rental deals online on Lumi. Select the car, pickup & dropoff branch and dates. 27 car rental locations in Saudi Arabia. Easy to book, Luxury car rental service.',
                ar: 'احصل على أفضل عروض تأجير السيارات عبر الإنترنت على Lumi. حدد السيارة، وفرع الاستلام و الإنزال والتواريخ. 27 موقع تأجير سيارات في المملكة العربية السعودية. سهلة الحجز، خدمة تأجير السيارات الفاخرة.',
            },
        },
        driver: {
            title: {
                en: 'Driver Information - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'معلومات السائق - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        payment: {
            title: {
                en: 'Payment - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'الدفع - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        paymentProcessing: {
            title: {
                en: 'Payment Processing - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'تجهيز المدفوعات - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        paymentStatus: {
            title: {
                en: 'Payment Status - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'حالة الدفع - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        confirm: {
            title: {
                en: 'Booking Confirmation - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'تأكيد الحجز - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        details: {
            title: {
                en: 'Booking Details - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'تفاصيل الحجز - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        account: {
            title: {
                en: 'Login/Sign up via Mobile - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'تسجيل الدخول / التسجيل عبر الهاتف المحمول - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        accountEmail: {
            title: {
                en: 'Login/Sign Up via Email - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'تسجيل الدخول / التسجيل عبر البريد الإلكتروني - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        profile: {
            title: {
                en: 'User Profile - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'ملف المستخدم - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        bookings: {
            title: {
                en: 'Bookings List Page - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'صفحة قائمة الحجوزات - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        about: {
            title: {
                en: 'About Us - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'من نحن - خدمة تأجير سيارات في السعودية | لومي',
            },
            description: {
                en: 'Lumi is part of Seera Group, the leading integrated travel service provider in the MENA region. Find out more about Lumi car rental.',
                ar: 'لومي هي جزء من مجموعة سيرا، الجهة الرائدة في تقديم خدمات السفر المتكاملة في منطقة الشرق الأوسط وشمال أفريقيا. اكتشف المزيد حول لومي لتأجير السيارات.',
            },
        },
        faq: {
            title: {
                en: 'FAQ - Frequently Asked Question about Car Rental | Lumi',
                ar: 'FAQ- الأسئلة المتكررة حول تأجير السيارات | لومي',
            },
            description: {
                en: 'Find the answer to your most common questions and read information on the car rental services we offer in Saudi Arabia.',
                ar: 'اعثر على الإجابة لأسئلتك الأكثر شيوعًا واقرأ المعلومات حول خدمات تأجير السيارات التي نقدمها في المملكة العربية السعودية.',
            },
        },
        privacy: {
            title: {
                en: 'Privacy Policy - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'سياسة الخصوصية - خدمة تأجير السيارات في السعودية | لومي',
            },
            description: {
                en: 'Lumi is committed to protecting the privacy of our users. This statement applies with respect to the information that we collect from our website as well as on mobile.',
                ar: 'تلتزم لومي بحماية خصوصية عملائها. وينطبق هذا البيان على المعلومات التي نجمعها من موقعنا على الإنترنت وكذلك على الهاتف المحمول.',
            },
        },
        terms: {
            title: {
                en: 'Terms & Conditions - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'الشروط والأحكام - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Find out more about our terms and condition of lumi car rental on this page.',
                ar: 'تعرف على المزيد حول شروط وأحكام تأجير سيارات لومي على هذه الصفحة.',
            },
        },
        404: {
            title: {
                en: '404 Page - This page could not be found',
                ar: 'صفحة 404 - لا يمكن العثور على هذه الصفحة',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        vehicles: {
            title: {
                en: 'Vehicles - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'المركبات - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: "Pick and choose from Lumi's new and well-maintained fleet of 56 different car types today!",
                ar: 'اختر من بين أسطول لومي الجديد المكون من 56 نوعًا مختلفًا من السيارات الجديدة, المحافظ عليها بالكامل!',
            },
        },
        locations: {
            title: {
                en: 'Locations - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'المواقع - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: "Visit Lumi now and find the branch nearest to you from Lumi's 20+ popular locations around the kingdom!",
                ar: 'قم بزيارة لومي الآن و ابحث عن أقرب فرع إليك من أكثر من 20 موقعًا شهيرًا في جميع أنحاء المملكة!',
            },
        },
        services: {
            title: {
                en: 'Services - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'الخدمات - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Enjoy speedy and convenient bookings, flexible payment options, and hassle free pick up and drop off solutions',
                ar: 'استمتع بحجوزات سريعة و مريحة, خيارات دفع مرنة, و حلول استلام و توصيل خالية من المتاعب مع لومي!',
            },
        },
        offers: {
            title: {
                en: 'Car Rental Offers - Best Deals to Hire a Car in Saudi Arabia | Lumi',
                ar: 'عروض تأجير السيارات - أفضل العروض لتأجير السيارات في السعودية | لومي',
            },
            description: {
                en: 'Car Rental Offers 2022 deals and discounts in Saudi Arabia. Check our latest offers of car hire on daily, weekly and monthly basis at the best rates. Quality car rental at a great value',
                ar: 'عروض وخصومات تأجير السيارات 2022 في السعودية. تحقق من احدث عروض تأجير السيارات بشكل يومي وأسبوعي وشهري وأحصل على افضل الاسعار. تأجير سيارات عالية الجودة بأفضل سعر.',
            },
        },
        carDelivery: {
            title: {
                en: 'Free Car Rental Delivery & Collection in Riyadh & Jeddah - LUMI',
                ar: 'وفر وقتك مع خدمة توصيل واستلام سيارات الايجار مجانية في الرياض وجدة - لومي',
            },
            description: {
                en: 'Enjoy getting your rental car delivered to your door step for FREE with Lumi! Rent a car for 30 days or more & pay online to avail the offer and a discount!',
                ar: 'استمتع بخدمة توصيل سيارتك المستأجرة إلى باب منزلك مجانًا مع لومي! استأجر سيارة لمدة 30 يومًا أو أكثر وادفع عبر الإنترنت للاستفادة من العرض والخصومات المتاحة',
            },
        },
        quickPay: {
            title: {
                en: 'Quick Pay - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'الدفع - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        quickPayPayment: {
            title: {
                en: 'Quick Pay Payment - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'الدفع - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        quickPayProcessing: {
            title: {
                en: 'Quick Pay Payment Processing - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'تجهيز المدفوعات - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        quickPayStatus: {
            title: {
                en: 'Quick Pay Status - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'حالة الدفع - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Looking to rent a car online? LUMI is one of the biggest car rental companies in Saudi Arabia that offers you best car rental experience at an affordable price. Clean Cars, New Car fleet, Easy to Book.',
                ar: 'تبحث لاستئجار سيارة عبر الإنترنت؟ LUMI (لومي) هي واحدة من أكبر شركات تأجير السيارات في المملكة العربية السعودية والتي تقدم لك أفضل تجربة لتأجير السيارات بسعر مناسب. سيارات نظيفة، أسطول سيارات جديد، سهولة الحجز.',
            },
        },
        ir: {
            title: {
                en: 'Investor Relations - Car Rental Service in Saudi Arabia | Lumi',
                ar: 'علاقات المستثمرين - خدمة تأجير السيارات في المملكة العربية السعودية | لومي',
            },
            description: {
                en: 'Discover Lumi Rental’s investor relations hub and learn more about our financial results, our growth strategy, and more.',
                ar: 'اكتشف مركز علاقات المستثمرين في LUMI (لومي) وتعرف على المزيد حول نتائجنا المالية واستراتيجية النمو لدينا والمزيد.',
            },
        },
        umrah: {
            title: {
                en: 'Umrah Bus Services from Jeddah, Madinah and many more',
                ar: 'لومي - خدمة حافلات نقل المعتمرين وزوار الحرمين الشريفين',
            },
            description: {
                en: 'Embark on your spiritual journey in ease and comfort with Lumi. Our premium bus rental services are designed to enhance your Umrah experience, providing convenient and reliable transportation. We are now available anywhere in the Western region, including Jeddah, Mecca, Medina, Taif, and Yanbu.',
                ar: ' انطلق برحلة تغمرها السكينة مع حافلات لومي. تم تهيئة خدماتنا لتعزيز تجربتك في أداء مناسك العمرة، وتوفير وسيلة نقل مريحة وموثوقة لك. بإمكاننا توصيل حافلاتنا إلى موقعك في أي نقطة في المنطقة الغربية، بما في ذلك جدة، مكة، المدينة، الطائف، وينبع.',
            },
        },
    },
};
